import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { AppContainer } from './AppContainer';
import { AuthContextProvider, AppProvider } from './contexts';
import { BrowserRouter } from 'react-router-dom';
import './services/localization/i18n'
import { QueryClient, QueryClientProvider } from 'react-query';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <QueryClientProvider client={new QueryClient()}>
      <AuthContextProvider>
        <BrowserRouter>
          <AppProvider>
            <AppContainer />
          </AppProvider>
        </BrowserRouter>
      </AuthContextProvider>
    </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
